import React from "react";
import ToggleField from "../../../components/inputs/toggleField";
import PagePreviewFrame from "../../../views/pages/components/pagePreviewFrame";
import FormSubmissionsModal from "./modals/formSubmissionsModal";

const ENV =
  process.env.NODE_ENV === "production"
    ? window.location.href.includes("planner.simple.events")
      ? `https://admin-api.simple.events/`
      : `https://beta-api.simple.events/`
    : `http://${window.location.hostname}:5015/`;

class CheckinFormSetup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      formSubmissionModalOpen: false,
    };
  }

  render() {
    const {
      checkInAppConfiguration,
      orgId,
      eventId,
      checkInFormId,
      editCount,
      handleChange,
      formManager,
      account,
    } = this.props;
    const { formSubmissionModalOpen } = this.state;
    return (
      <div className="sectionBody">
        <div className="blocksContainer">
          <div className="flex w-100">
            <div className="sectionBlock mr-25 contained-h">
              <h2 className="blockHeader">Configure</h2>
              <ToggleField
                label="Show Profile Picture"
                checked={checkInAppConfiguration.showProfilePicture}
                onChange={(e) => {
                  handleChange({ showProfilePicture: e.target.checked });
                }}
                icons={false}
              />
            </div>
            <div
              className="sectionBlock  emailDesignPreview mt-20 "
            >

              <div
                style={{
                  width: 590,
                  maxWidth: "calc(100% - 15px)",
                  minWidth: "calc(100% - 700px)",
                }}
                className="cardDetailsContainerPages containerTitle mb-20"
              >
                <div className="w-100">
                  <h2 className="blockHeader m-0">Form Builder</h2>
                </div>

                {!checkInAppConfiguration.checkInForm ? (
                  <button
                    className="neu ml-a"
                    onClick={formManager.toggleFormEditorModal}
                  >
                    Add Form
                  </button>
                ) : (
                  <div className="flex aic ml-a">
                    <button
                      className="neu mr-10"
                      onClick={() =>
                        this.setState({ formSubmissionModalOpen: true })

                      }
                    >
                      View Submissions
                    </button>

                    <button
                      className="neu prim"
                      onClick={formManager.toggleFormEditorModal}
                    >
                      Edit Form
                    </button>
                  </div>
                )}
              </div>
              <div
                style={{
                  width: 590,
                  maxWidth: "calc(100% - 15px)",
                  minWidth: "calc(100% - 700px)",
                  height: 500,
                }}
              >
                <div className="emailPreview eFrame pages flex-ac preview">
                { checkInFormId && <PagePreviewFrame
                    ENV={ENV}
                    key={`checkin-${editCount}`}
                    renderURL={`Organizations/${orgId}/events/${eventId}/pages/render/formRender/`}
                    pageProperties={{}}
                    focusedComponent={""}
                    simulatedUser={{ value: account._id }}
                    simulatedSession={{ value: false }}
                    renderOnly={true}
                    formId={checkInFormId}
                    preview={true}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>

        {formSubmissionModalOpen && <FormSubmissionsModal
          isOpen={formSubmissionModalOpen}
          toggle={() => this.setState({ formSubmissionModalOpen: false })}
          form={checkInAppConfiguration.checkInForm}
          formType={"checkInForm"}
          orgId={this.props.orgId}
          eventId={this.props.eventId}
          event={this.props.event}
        />}
      </div>
    );
  }
}

export default CheckinFormSetup;
